import { skipToken, useQuery } from '@tanstack/react-query';
import { orpc } from '@/api/rpc/client';
import type {
  APInvoice,
  ListAPInvoicesInput,
  ListAPInvoicesResponse,
  GetAPInvoiceResponse,
} from '@erp/rpc';

export function useAPInvoicesList(filters: ListAPInvoicesInput = {}) {
  const query = useQuery(
    orpc.accountsPayable.invoices.list.queryOptions({
      input: {
        ...filters,
        includeNumLineItemsMatched: true,
      },
    }),
  );

  const invoices = query.data?.invoices ?? [];
  const pagination = query.data?.pagination;

  return {
    ...query,
    invoices,
    pagination,
  } satisfies typeof query & {
    data?: ListAPInvoicesResponse;
    invoices: APInvoice[];
    pagination: ListAPInvoicesResponse['pagination'] | undefined;
  };
}

export function useAPInvoice(id: string | undefined, enabled = true) {
  const query = useQuery({
    ...orpc.accountsPayable.invoices.get.queryOptions({
      input: id ? { id } : skipToken,
    }),
    enabled: Boolean(id) && enabled,
  });

  return {
    ...query,
    invoice: query.data ?? null,
  } satisfies typeof query & {
    data?: GetAPInvoiceResponse;
    invoice: GetAPInvoiceResponse | null;
  };
}
